import request from '@/utils/request'
import { encryptedData } from '@/utils/encrypt'
import { loginRSA, publicPath, authUrl } from '@/config'

export async function login(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    url: '/api/login',
    method: 'post',
    data,
  })
}

export async function socialLogin(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    url: '/socialLogin',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/api/userInfo',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/api/logout',
    method: 'get',
  })
}
export function oauth2logout() {
  return request({
    url: `${authUrl}${publicPath}works-partner/logout`,
    method: 'get',
  })
}
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}
